export default __webpack_public_path__ + "static/media/galerie5.98cde4b9.png";